import type { WorkItemDto } from '@customTypes/types';

import { ManageWorkRequestView } from './ManageWorkRequestView';
import { useManageWorkRequestView } from './useManageWorkRequestView';

export const ManageWorkRequestContainer = ({
  workItem
}: {
  workItem: WorkItemDto;
}) => {
  const {
    functions: { accept, reject }
  } = useManageWorkRequestView({ workItem });
  return <ManageWorkRequestView accept={accept} reject={reject} />;
};
